import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BaseBordereauState from './BaseBordereauState';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BordereauMettreEnEchecAction from '../actions/BordereauMettreEnEchecAction';
import BordereauActualiseEtatAction from '../actions/BordereauActualiseEtatAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';

class BordereauTransmisComptableState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.TRANSMIS_COMPTABLE;
    this.state = BordereauStateType.TRANSMIS_COMPTABLE;
    this.color = '#9747FF';
    this.libelle = 'Transmis au comptable';
  }

  getBordereauActions(
    _bordereau: BordereauWithState,
    userRole: UserRole,
  ): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauActualiseEtatAction({ isActionPrincipale: true }),
      new BordereauDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauModifierAction({ isSuperUser: true }),
        new BordereauMettreEnEchecAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauTransmisComptableState;
